import ProcessingDashboard from "./ProcessingDashboard";
import PDFExtractionEngine from "./PDFExtractionEngine";
import FairScheduler from "./FairScheduler";
import ValidationReview from "./ValidationReview";
import AuditReporting from "./AuditReporting";

export default function CIBAutomationPanel({ project }) {
  return (
    <div className="space-y-8">
      <ProcessingDashboard />
      <PDFExtractionEngine />
      <FairScheduler />
      <ValidationReview />
      <AuditReporting />
    </div>
  );
}
